const fields = ['Name', 'Phone', 'Address', 'City', 'Zipcode'];

// Parse quoted commas, escaped quotes and embedded newlines without converting phone or ZIP values to numbers.
export function parseUsbLabelCsv(text) {
    const input = text.replace(/^\uFEFF/, '');
    const records = [];
    let row = [];
    let value = '';
    let quoted = false;
    let afterQuote = false;
    for (let i = 0; i < input.length; i += 1) {
        const char = input[i];
        if (quoted) {
            if (char === '"' && input[i + 1] === '"') { value += '"'; i += 1; }
            else if (char === '"') { quoted = false; afterQuote = true; }
            else value += char;
        } else if (char === ',' || char === '\n' || char === '\r') {
            row.push(value); value = ''; afterQuote = false;
            if (char !== ',') {
                records.push(row); row = [];
                if (char === '\r' && input[i + 1] === '\n') i += 1;
            }
        } else if (char === '"' && value === '' && !afterQuote) quoted = true;
        else if (afterQuote || char === '"') throw new Error('Invalid CSV quoting. Please check the file.');
        else value += char;
    }
    if (quoted) throw new Error('Unclosed quoted field in CSV.');
    if (row.length || value || afterQuote) { row.push(value); records.push(row); }
    const header = (records.shift() || []).map(cell => cell.trim().toLowerCase());
    const indexes = fields.map(field => header.indexOf(field.toLowerCase()));
    if (indexes.some(index => index < 0) || fields.some(field => header.filter(cell => cell === field.toLowerCase()).length !== 1)) {
        throw new Error('CSV must contain one each of these headers: Name, Phone, Address, City, Zipcode.');
    }
    const rows = records.map((record, index) => {
        if (!record.some(cell => cell.trim())) return null;
        const values = indexes.map(column => (record[column] || '').trim());
        const missing = fields.filter((_, column) => !values[column]);
        return {
            key: index + 2,
            name: values[0], phone: values[1], address: values[2], city: values[3], zipcode: values[4], missing,
            registrant: { performers: [{ fullName: values[0], phoneNumber: values[1], addressLine: values[2], city: values[3], zipCode: values[4] }] },
        };
    }).filter(Boolean);
    if (!rows.length) throw new Error('The CSV contains no label rows.');
    return rows;
}
